module.exports = __webpack_public_path__ + "media/images/icons/close_s-8d7de2a2e2125f6c280db2f2df7dcb02.svg";